import React, { useState, useEffect, useRef } from 'react';
import './styles.css';
import { Link } from 'react-router-dom';
import { BsArrowRightShort } from 'react-icons/bs';

const ProgramsFilter = () => {
  const tabs = [
    { id: 'lab', name: 'Oxetech lab', fields: ['laboratorio'] },
    { id: 'work', name: 'Oxetech work', fields: ['interesse', 'salario', 'atuacao'] },
    { id: 'trilhas', name: 'Oxetrilhas', fields: ['interesse'] },
    { id: 'din', name: 'Oxedin', fields: ['interesse', 'salario', 'atuacao'] }
  ];


  const [activeTab, setActiveTab] = useState('lab');
  const [searchText, setSearchText] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedInterest, setSelectedInterest] = useState('');
  const [selectedSalary, setSelectedSalary] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const activeTabRef = useRef(null);


  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      const currentIndex = tabs.findIndex(tab => tab.id === activeTab);
      const nextIndex = (currentIndex + 1) % tabs.length;
      setActiveTab(tabs[nextIndex].id);
    }, 8000);

    return () => clearInterval(interval);
  }, [activeTab, tabs]);

  const getTabUrl = () => {
    if (activeTab === "work") {
      return "/oxetechwork"
    }
    if (activeTab === "lab") {
      return "/oxetechlabdivulgacao"
    }
    if (activeTab === "din") {
      return "/oxedin"
    }
  };

  const handleReset = () => {
    setSearchText('');
    setSelectedCity('');
    setSelectedInterest('');
    setSelectedSalary('');
    setSelectedArea('');
  };

  // Determina o placeholder do input com base no tamanho da tela
  const getPlaceholder = () => {
    if (windowWidth <= 480) {
      return "Pesquisar...";
    } else if (windowWidth <= 768) {
      return "Digite para pesquisar...";
    }
    return "Digite o que você procura...";
  };

  return (
    <div className="navigation-container_filter">
      {/* Tab navigation */}
      <div className="tabs_filter">
        {tabs.map(tab => (
          <button
            key={tab.id}
            ref={activeTab === tab.id ? activeTabRef : null}
            className={`tab_filter ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {/* Filter form */}

      <div className="filter-form">
        <div className="filter-fields">
          {/* Show interest field for specific tabs */}
          {tabs.find(tab => tab.id === activeTab)?.fields.includes('interesse') && (
            <div className="filter-field">
              <div className="field-wrapper">
                <i className="icon">📋</i>
                <select
                  value={selectedInterest}
                  onChange={(e) => setSelectedInterest(e.target.value)}
                >
                  <option value="">Interesse profissional</option>
                  <option value="desenvolvimento">Desenvolvimento Front-end</option>
                  <option value="desenvolvimento">Desenvolvimento Back-end</option>
                  <option value="desenvolvimento">Desenvolvimento Full-stack</option>
                  <option value="design">Design</option>
                  <option value="marketing">Marketing</option>
                  <option value="gestor">Gestor de Tráfego</option>

                </select>
                <i className="dropdown-icon">▼</i>
              </div>
            </div>
          )}

          {/* Show salary field for specific tabs */}
          {tabs.find(tab => tab.id === activeTab)?.fields.includes('salario') && (
            <div className="filter-field">
              <div className="field-wrapper">
                <i className="icon">💰</i>
                <select
                  value={selectedSalary}
                  onChange={(e) => setSelectedSalary(e.target.value)}
                >
                  <option value="">Possibilidade salarial</option>
                  <option value="1000-3000">R$ 1.000 - R$ 2.000</option>
                  <option value="3000-5000">R$ 2.000 - R$ 5.000</option>
                  <option value="5000+">Acima de R$ 5.000</option>
                </select>
                <i className="dropdown-icon">▼</i>
              </div>
            </div>
          )}

          {/* Show area field for specific tabs */}
          {tabs.find(tab => tab.id === activeTab)?.fields.includes('atuacao') && (
            <div className="filter-field">
              <div className="field-wrapper">
                <i className="icon">🏢</i>
                <select
                  value={selectedArea}
                  onChange={(e) => setSelectedArea(e.target.value)}
                >
                  <option value="">Área de atuação</option>
                  <option value="tecnologia">Tecnologia</option>
                  <option value="saude">Saúde</option>
                  <option value="educacao">Educação</option>
                  <option value="economiaCriativa">Economia criativa</option>
                </select>
                <i className="dropdown-icon">▼</i>
              </div>
            </div>
          )}

          {tabs.find(tab => tab.id === activeTab)?.fields.includes('laboratorio') && (
            <div className="filter-field">
              <div className="field-wrapper">
                <i className="icon">📍</i>
                <select
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                >

                  <option value="">Selecione o laboratório</option>
                  <option value="maceio">Maceió</option>
                  <option value="arapiraca">Arapiraca</option>
                  <option value="batalha">Batalha</option>
                  <option value="pao de acucar">Pão de açucar</option>
                  <option value="murici">Murici</option>
                  <option value="penedo">Penedo</option>
                  <option value="delmiro gouveia">Delmiro Gouveia</option>
                  <option value="santana do ipanema">Santana do Ipanema</option>
                  <option value="traipu">Traipu</option>
                  <option value="arapiraca">Arapiraca</option>
                  <option value="benedito bentes">Benedito Bentes</option>
                </select>
                <i className="dropdown-icon">▼</i>
              </div>
            </div>
          )}

        </div>

        {activeTab === 'trilhas' ? (
          <div className="trilhas-info">
            <h2>Explore as trilhas de conhecimento do programa Oxetrilhas!</h2>
            <Link
              className="acess-button"
              to='/login'
            >
              Acesse <BsArrowRightShort style={{ verticalAlign: 'middle' }} size={25} />
            </Link>
          </div>
        ) : (
          <div className="search-box">
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={getPlaceholder()}
            />
            <div className="button-group">
              <Link to={getTabUrl} className="reset-button">
                Pesquisar
              </Link>
              <button className="reset-button" onClick={handleReset} aria-label="Resetar filtros">
                ↻
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default ProgramsFilter;